import React from 'react'

const Header = ({ title, author, _createdAt, addClass }) => {
  return (
    <header className={`blog-head ${addClass == undefined ? '' : addClass}`}>
      <h1>{title}</h1>
      <p>
        By : {author.name} | {_createdAt}
      </p>
      <hr className="header-hr" />
    </header>
  )
}

export default Header
